import { defineComponent as n, computed as o, openBlock as c, createElementBlock as a, createElementVNode as e, toDisplayString as d, createCommentVNode as f, normalizeStyle as _ } from "vue";
const h = ["viewBox"], u = /* @__PURE__ */ e("mask", { id: "8a4dde31-db39-44a3-a3fe-fb5e123cfdc2" }, [
  /* @__PURE__ */ e("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), m = { mask: "url(#8a4dde31-db39-44a3-a3fe-fb5e123cfdc2)" }, k = { key: 0 }, p = /* @__PURE__ */ e("path", {
  fill: "#eee",
  d: "M0 0h512v512H0z"
}, null, -1), v = /* @__PURE__ */ e("path", {
  fill: "#333",
  d: "M345.1 216.8A98 98 0 0 0 157.5 177l-12 43.8 11 11.2-22.2 44.5 22.3 11.1-11.2 11.1V310l11.2 11.1v22.3l11.1 11 33.4-11s0 11 11.1 22.2 22.3 33.4 22.3 33.4 33.4 11.1 55.6-22.2c22.3-33.4 44.6-44.6 44.6-44.6l-21.5-42.9a98 98 0 0 0 32-72.4z"
}, null, -1), g = /* @__PURE__ */ e("path", {
  fill: "#acabb1",
  d: "M353.1 254.3c45.3-7.6 52.8-96.2 52.8-96.2h-62.3c32.2 78-1.5 83.2-1.5 83.2a8110 8110 0 0 0-173.6-83c-1.3 1.7-5.9 6-11.5 19.8-5.6 13.7-7 26-7 26a6870 6870 0 0 0 181.2 63c9.2 5.9 20.4 23.7 14.1 76.6l60-16.9s-20.4-54.1-52.2-72.5z"
}, null, -1), x = { fill: "none" }, w = ["r"], z = /* @__PURE__ */ n({
  __name: "fr-20r",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(i) {
    const t = i, l = o(() => 512 + 2 * t.strokeWidth), s = o(() => -t.strokeWidth), r = o(() => 256 + t.strokeWidth / 2);
    return (b, y) => (c(), a("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${s.value} ${s.value} ${l.value} ${l.value}`
    }, [
      u,
      e("g", m, [
        t.flagName ? (c(), a("title", k, d(t.flagName), 1)) : f("", !0),
        p,
        v,
        g
      ]),
      e("g", x, [
        e("circle", {
          cx: "256",
          cy: "256",
          r: r.value,
          fill: "none",
          style: _({ stroke: t.strokeColor, strokeWidth: t.strokeWidth })
        }, null, 12, w)
      ])
    ], 8, h));
  }
});
export {
  z as default
};
//# sourceMappingURL=fr-20r-3a3d660b.js.map
